import { useMemo } from 'react';

import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import { useAppDispatch } from 'src/app/store/hooks';
import { MultiSelectFilterPopover } from 'src/common/primitives/FilterPopover/MultiSelectFilterPopover';
import { apiDaysOfWeekToLocalDaysMap } from 'src/features/trip/routeTemplates/forms/daysOfWeekMaps';

interface DaysOfWeekColumnFilterProps {
  open: boolean;
  onClose: () => void;
  selected: string[];
  setSelectedAction: ActionCreatorWithPayload<string[], string>;
}

export function DaysOfWeekColumnFilter({
  open,
  onClose,
  selected,
  setSelectedAction,
}: DaysOfWeekColumnFilterProps) {
  const dispatch = useAppDispatch();
  const daysOfWeekOptions = Object.entries(apiDaysOfWeekToLocalDaysMap).map(
    ([key, value]) => ({
      id: key,
      label: value,
    })
  );

  const selectedValues = useMemo(() => {
    return daysOfWeekOptions.filter((v) => selected.includes(v.id));
  }, [daysOfWeekOptions, selected]);

  return (
    <MultiSelectFilterPopover
      open={open}
      value={selectedValues}
      filters={daysOfWeekOptions}
      renderLabel={({ label }) => label}
      onCancel={onClose}
      onChange={(values) =>
        dispatch(setSelectedAction(values.map((v) => v.id as string)))
      }
      triggerElement={<div data-testid="days-of-week-column-filter-trigger" />}
    />
  );
}
